import platform from '../../../util/platform';
import History from '../../../util/history';
class Listener {
    constructor(preprocessor) {
        this.listener = null;
        this.preprocessor = preprocessor;
    }
    addListener(listener) {
        this.listener = listener;
    }
    removeListener(listener) {
        this.listener = null;
    }
    fire(message) {
        if (this.listener) {
            if(this.preprocessor) {
                message = this.preprocessor(message);
            }
            this.listener(message);
        }
    }
}

let extensionId = 'jmmkbcfakiendpnceenfanaebjenjene';
class ChromeDelegate {
    constructor() {
        this.isAppInstalled;
        this.messageHandleMap = {};
        this.port = chrome.runtime?chrome.runtime.connect(extensionId, {
            name: "mBlock.hardware"
        }):null;
        console.log('connect chrome ',this.port)
        if(this.port){
            this.port.onMessage.addListener((message) => {
                // console.log('ChromeDelegate.onMessage receive message ', message);
                if (this.messageHandleMap[`${message.connectType}.${message.method}`]) {
                    this.messageHandleMap[`${message.connectType}.${message.method}`].fire(message);
                }
            });
            if(platform.isChromeOS){
                this.sendMessage({cmd:'getVersion'},(err,message)=>{
                    if(message && message.version=='mBlock.hardware'){
                        this.isAppInstalled = true;
                        console.log('插件已安装');
                    }else{
                        this.isAppInstalled = false;
                        console.log('插件未安装！！');
                    }
                });
            }
            
        } else {
            this.isAppInstalled = false;
            console.log('插件未安装！！');
        }
    }
    showNoDriverTip() {
        setTimeout(()=>{
            let path = `/nochromedriver`;
            if (History.location.pathname !== path) {
                History.replace(path);
            }
        },3000);
        
    }
    createListeners(connectType, method, preprocessor) {
        let l = new Listener(preprocessor);
        this.messageHandleMap[`${connectType}.${method}`] = l;
        return l;
    }
    sendMessage(message, callback) {
        chrome.runtime.sendMessage(extensionId, message,
            (resp) => {
                if(chrome.runtime.lastError) {
                    console.error(chrome.runtime.lastError);
                    callback(chrome.runtime.lastError, null);
                }
                if (resp.errcode == 0) {
                    callback(null, resp.resp);
                } else {
                    console.log('ChromeDelegate reply error ', resp);
                    callback({ errcode: resp.errocode, errmsg: resp.errmsg }, {});
                }
            });
    }

    isConnected(){
        return this.isAppInstalled;
    }

}
let inst = new ChromeDelegate();
export default inst;